import { RocketDuotone } from '@griply/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { Icon } from 'shared/components/ui/icon';

import { Faq } from '../faq';
import { PricingCard } from '../pricing-card';
import { Reviews } from '../reviews';
import * as Styled from './premium-layout.style';

export type PremiumLayoutProps = {
  toggle: React.ReactNode;
  price: React.ReactNode;
  cta: React.ReactNode;
  onSkip: () => void;
};

export const PremiumLayout: React.FC<PremiumLayoutProps> = ({
  toggle,
  price,
  cta,
  onSkip,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.OnboardingContainer>
      <Styled.Page>
        <Styled.Hero>
          <Styled.HeroIcon>
            <Icon icon={RocketDuotone} strokeWidth={2} />
          </Styled.HeroIcon>
          <Styled.HeroTitle>
            {t('forms.onboarding.premium.title')}
          </Styled.HeroTitle>
          <Styled.Subtitle>
            {t('forms.onboarding.premium.subtitle')}
          </Styled.Subtitle>
        </Styled.Hero>

        <PricingCard toggle={toggle} price={price} cta={cta} />

        <Styled.ContinueFree>
          <Button
            type="button"
            onClick={onSkip}
            variant={Variants.Text}
            size={Sizes.Medium}
            color={Colors.Inherit}
            alignCenter
          >
            {t('forms.onboarding.premium.continue-free')}
          </Button>
        </Styled.ContinueFree>

        <Reviews />

        <Faq />
      </Styled.Page>
    </Styled.OnboardingContainer>
  );
};
